import { sysMana, sysmana } from '@/api/index'

export function getGridColumnsByGridID (data) {
  return sysmana.request({
    method: 'post',
    url: '/GetGridColumnsByGridID',
    data
  })
}

export function getGridUserSettings (data) {
  return sysmana.request({
    method: 'post',
    url: '/GetGridUserSettings',
    data
  })
}

export function getGridColumns (data) {
  return sysmana.request({
    method: 'post',
    url: '/GetGridColumns',
    data
  })
}

export function getExportModelMain (data) {
  return sysMana.request({
    method: 'post',
    url: '/GetExportModelMain',
    data
  })
}
export function GetBackData (data: any) {
  return sysMana.request({
    method: 'post',
    url: '/GetBackData',
    data
  })
}
export function GetDataDictionary (data: any) {
  return sysMana.request({
    method: 'post',
    url: '/GetDataDictionary',
    data
  })
}
export function GridManaQuery (data: any) {
  return sysMana.request({
    method: 'post',
    url: '/GridManaQuery',
    data
  })
}

export function GetPageGridBond (data: any) {
  return sysMana.request({
    method: 'post',
    url: '/GetPageGridBond',
    data
  })
}
export function SavePGSData (data: any) {
  return sysMana.request({
    method: 'post',
    url: '/SavePGSData',
    data
  })
}
